export type DeletePromptReplyErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class DeletePromptReplyError extends Error {
    code: DeletePromptReplyErrorCode;
    constructor(code: DeletePromptReplyErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
